
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drinks",
      function () {
        return require("private-next-pages/drinks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drinks"])
      });
    }
  